module.exports = __webpack_public_path__ + "img/laboratorio5_4-3_2048.8b3a03c5.webp";